import React, { useState } from 'react';

const ErrorMessage = ({ message, onRetry }) => {
  const [showDetails, setShowDetails] = useState(false);
  
  return (
    <div className="card" style={{ borderColor: 'rgba(255, 100, 100, 0.5)', textAlign: 'left' }}>
      <h3 style={{ color: '#ff6b6b' }}>Something went wrong</h3>
      <p>{message?.split('\n')[0] || 'There was an error processing your request.'}</p>
      
      {message?.includes(':') && (
        <div style={{ marginTop: '1rem' }}>
          <button 
            onClick={() => setShowDetails(!showDetails)}
            style={{ 
              background: 'transparent', 
              border: '1px solid rgba(255, 100, 100, 0.5)',
              color: '#ff6b6b',
              padding: '0.3rem 0.8rem',
              fontSize: '0.9rem',
              marginBottom: '1rem'
            }}
          >
            {showDetails ? 'Hide Details' : 'Show Details'}
          </button>
          
          {showDetails && (
            <pre style={{ 
              padding: '1rem', 
              background: 'rgba(0,0,0,0.2)', 
              borderRadius: '5px',
              overflowX: 'auto',
              fontSize: '0.9rem',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }}>
              {message}
            </pre>
          )}
        </div>
      )}
      
      <div style={{ marginTop: '1.5rem' }}>
        {onRetry && (
          <button onClick={onRetry}>Try Again</button>
        )}
        <button 
          onClick={() => window.location.href = '/?debug=true'}
          style={{ marginLeft: '1rem' }}
        >
          Go to Debug Page
        </button>
      </div>
    </div>
  );
};

export default ErrorMessage;
